var stone_enquiry = ( function( $ ) {

	var $popup,
		$link;

	var _init = function() {
		$popup = $( '#enquiry-popup' );
		$link  = $( '.open-enquiry-form' );

		_setup_form()

		$popup.find( 'a.close-popup' ).on( 'click', _close_popup );
		$link.on( 'click', _open_popup );
	};

	var _disable_fields = function() {
		$popup.find( 'li.gf-readonly input' ).attr( 'readonly', 'readonly' ).addClass( 'read-only' );
	};

	var _open_popup = function( e ) {
		e.preventDefault();

		$popup.fadeIn();

		$( 'html body' ).addClass( 'open-popup' );
	};

	var _close_popup = function( e ) {
		e.preventDefault();

		$popup.fadeOut();

		setTimeout( function() {
			$( 'html body' ).removeClass( 'open-popup' );
		}, 300 );
	};

	var _setup_form = function() {
		var $form = $popup.find( 'form' );

		_disable_fields();
		_setup_file_upload( $form );
	}

	var _setup_file_upload = function($form) {
		var $file_upload = $form.find( 'input[type="file"]' ),
			$wrapper = $file_upload.closest( 'li' ),
			$label = $wrapper.find( 'label' );

		_update_file_label( $file_upload, $label );

		$wrapper.append( '<a href="#" class="clear-file-input" title="Clear"></a>' );

		setTimeout( function () {
			$wrapper.find( '.clear-file-input' ).on( 'click', function( e ) {
				e.preventDefault();

				$file_upload.val( '' );
				$file_upload.trigger( 'change' );
			} );
		}, 100 );

		$file_upload.on( 'change', function() {
			_update_file_label( $file_upload, $label );
		} );
	}

	var _update_file_label = function($input, $label) {
		if ( $input.get( 0 ).files.length !== 0 ) {
			$label.closest( 'li' ).addClass( 'has-file' );
			$label.text( $input.val().replace( /C:\\fakepath\\/i, '' ) );
		} else {
			$label.closest( 'li' ).removeClass( 'has-file' );
			$label.text( 'Upload a photo, image or drawing' );
		}
	}

	if ( $( '.open-enquiry-form' ).length > 0 && $( '#enquiry-popup' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

} )( jQuery );

module.exports = stone_enquiry;